import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateWorkItem } from 'queries';

import Modal from 'common/modal';

import TaskActivityNotes from './task-activity-notes';
const useStyles = makeStyles(() => ({
  container: {
    padding: '20px',
    color: '#1C2541',
    fontSize: '14px',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '80vh',
    textAlign: 'left',
  },
}));
type TaskActivityNotesModalProps = {
  estateWorkItem: EstateWorkItem;
  onClose: () => void;
};

const TaskActivityNotesModal = ({ estateWorkItem, onClose }: TaskActivityNotesModalProps) => {
  const classes = useStyles();

  return (
    <Modal
      setShowModal={() => {}}
      onExitClick={onClose}
      showModal={true}
      showActions={false}
      content={
        <div className={classes.container}>
          <Typography>{estateWorkItem.workText}</Typography>
          <TaskActivityNotes estateWorkItem={estateWorkItem} />
        </div>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};
export default TaskActivityNotesModal;
